export type ValueType =
  "boolean" | "number" | "string" | "array" | "object" | "null";

export interface ScanResultInput {
  identifier?: string;
  label?: string;
  value: unknown;
  valueType: ValueType;
  answer?: string;
  explanation?: string;
  metadata?: Record<string, unknown>;
  validationResult?: boolean | Record<string, boolean>;
  validationTarget?: unknown;
}

interface ValueOnly {
  value: unknown;
  valueType: ValueType;
}

export function isStringValue<T extends ValueOnly>(
  r: T
): r is T & { valueType: "string"; value: string } {
  return r.valueType === "string";
}

export function isNumberValue<T extends ValueOnly>(
  r: T
): r is T & { valueType: "number"; value: number } {
  return r.valueType === "number";
}

export function isBooleanValue<T extends ValueOnly>(
  r: T
): r is T & { valueType: "boolean"; value: boolean } {
  return r.valueType === "boolean";
}

export function isNullValue<T extends ValueOnly>(
  r: T
): r is T & { valueType: "null"; value: null } {
  return r.valueType === "null";
}

export function isArrayValue<T extends ValueOnly>(
  r: T
): r is T & { valueType: "array"; value: unknown[] } {
  return r.valueType === "array";
}

export function isObjectValue<T extends ValueOnly>(
  r: T
): r is T & { valueType: "object"; value: Record<string, unknown> } {
  return r.valueType === "object";
}

export function inferValueType(value: unknown): ValueType {
  if (value === null) return "null";
  if (typeof value === "boolean") return "boolean";
  if (typeof value === "number") return "number";
  if (typeof value === "string") return "string";
  if (Array.isArray(value)) return "array";
  if (typeof value === "object") return "object";
  return "string";
}
